import TTLProxy from "../../TTLAsyncProxy";
import {UserRoles} from "../../Constants";
import {broadcastEvent} from "../../Events/EventSource";
import history from "../../../history";
import Utils from "../../Utils";
import CurrencyLabel from "../../../components/CurrencyLabel/CurrencyLabel";
import PropTypes from "prop-types";
import React from "react";
import NotificationTemplate from "./NotificationTemplate";
import EventActions from "../../Events/Actions";
import {formatServiceQuantity} from "../../QuantityHelper";

const handleTractorRequestClicked = (request) => {

    const proxy = TTLProxy.getInstance();
    switch (proxy.getUserRole()) {

        case UserRoles.Admin:

            //  toggle tractor request handler
            broadcastEvent( EventActions.ActiveTractorRequestHandler, request.id);

            break;
        case UserRoles.FBO:
        case UserRoles.Owner:
        case UserRoles.Farmer:
        case UserRoles.CallCenterAgent:

            //  filter in requests view
            history.push(`/requests?filter_id=${request.id}&q=${request.order_id}`);

            break;
    }

};

const getFieldProperty = (field,request) => {

    let title , value;
    switch (field){
        case "id":
            title = "Request ID";
            value =  request.order_id || request.id;
            break;
        case "name":
            title = "Name";
            value = request.name;
            break;
        case "phone":
            title = "Phone No.";
            value = request.phone;
            break;
        case "txn_phone":
            title = "Phone No. (Payment)";
            value = request.txn_phone;
            break;
        case "location":
            title = "Location";
            value = request.location;
            break;
        case "acres":
        case "hectares":
        case "quantity":
            title = "Quantity";
            value = formatServiceQuantity(request, { acre: 'acres' , hectare: 'hectares' , service: request.service });
            break;
        case "service":
            title = "Service";
            value = request.service.name;
            break;
        case "cost":
            title = "Cost";
            value = <CurrencyLabel value={request.cost}/>;
            break;
        case "date_completed":
            title = "Time Completed";
            value = Utils.formatDateStandard(request.date_completed);
            break;
        case "date_started":
            title = "Start Time";
            value = Utils.formatDateStandard(request.date_started);
            break;
        case "date_created":
            title = "Time Sent";
            value = Utils.formatDateStandard(request.date_created);
            break;
    }

    return {
        title,
        value
    };

};

const TractorRequestNotification = (props) => {

    const request = props.request;
    const fields = props.fields || [];

    return <NotificationTemplate icon={props.icon}
                                 title={props.title}
                                 hint={props.hint ? props.hint(request) : null}
                                 properties={fields.map(x => getFieldProperty(x,request))}
                                 onClick={() => {

                                     handleTractorRequestClicked(request);

                                     if(props.onClick)
                                         props.onClick();
                                 }}/>
};

TractorRequestNotification.propTypes = {
    title: PropTypes.any,
    hint: PropTypes.any,
    icon: PropTypes.any,
    fields: PropTypes.any,
    onClick: PropTypes.func
};

TractorRequestNotification.defaultProps = {
    icon : "fa fa-bell"
};

export default TractorRequestNotification;



// WEBPACK FOOTER //
// ./src/common/UserNotifications/PopupTemplates/TractorRequestNotification.js